module.exports = __webpack_public_path__ + "assets/thumb-clinic@2x.7c8b0ea0.png";